import GameLayout from '~/pages/authentified/GameLayout';
import styled from 'styled-components';
import { Menu } from '~/components/ui/menu';
import logo from '@assets/images/logo/logo-trainpursuit.png';
import { SquareItem } from '~/components/ui/square-item';
import ButtonSolo from '~/components/ui/button-solo';
import { useNavigate, useParams } from 'react-router-dom';
import ButtonBattle from '~/components/ui/button-battle';
import { useEffect, useState } from 'react';
import { RulesItem } from '~/components/ui/rules-item';
import LeaderBoardDialog from '~/components/game/leaderboard-dialog';
import FriendsdDialog from '~/components/game/friends-dialog';
import RulesDialog from '~/components/game/rules-dialog';

import { useQuery, useSubscription } from '@apollo/client';
import { authClient, wsClient } from '~/helpers/apollo';
import { notification } from 'antd';
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  ThunderboltOutlined,
} from '@ant-design/icons';
import ButtonText from '~/components/ui/button-text';
import { useAuth } from '~/helpers/store/auth';
import { SDivRules, SSpan, SSpanText } from '~/components/styles/styles';
import { classic } from '~/themes';
import { useLingui } from '@lingui/react';
import RulesClassementDialog from '~/components/game/rules-classement-dialog';
import { GQL_BATTLE_SUBSCRIPTION } from '~/gql/notifications/notifications';
import { NotificationType } from '@zeus/index';
import ChallengeListDialog from '~/components/game/challendge-list-dialog';
import { GQL_CHECK_BATTLES, GQL_FINISHED_BATTLES } from '~/gql/battles/battles';

function Home() {
  const navigate = useNavigate();
  const { payload } = useAuth();
  const { i18n } = useLingui();
  const [isLeaderBoardOpen, setIsLeaderBoardOpen] = useState<boolean>(false);
  const [isFriendsOpen, setIsFriendsOpen] = useState<boolean>(false);
  const [isRulesOpen, setIsRulesOpen] = useState<boolean>(false);
  const [hasNotifications, setNotifications] = useState<boolean>(false);
  const { index } = useParams();
  const [indexPage, setIndexPage] = useState<'classement' | 'amis' | undefined>(
    undefined
  );
  const [isRulesNotSeen, setIsRulesNotSeen] = useState<boolean>(false);
  const [isChallengeListOpen, setIsChallengeListOpen] =
    useState<boolean>(false);

  useSubscription(GQL_BATTLE_SUBSCRIPTION, {
    client: wsClient,
    variables: {
      username: payload?.username ?? '',
    },
    onData: async ({ data: { data } }) => {
      if (data?.battleSubscription?.type === NotificationType.NEXT_TURN) {
        notification.info({
          icon: (
            <ThunderboltOutlined
              style={{ color: `${classic.token?.colorFillSecondary}` }}
            />
          ),
          message: (
            <SSpan $color={`${classic.token?.colorText}`}>
              {i18n._('battle.turn.ended')}
            </SSpan>
          ),
          duration: 0,
          description: (
            <>
              <SSpanText>
                {`${data?.battleSubscription.from} ${i18n._('battle.notification.next')}`}
              </SSpanText>
              <SDiv>
                <ButtonText
                  color="secondary"
                  onClick={() => {
                    navigate(
                      `/mode-battle/defis/${data.battleSubscription?.battlePlayerTrackingId}`
                    );
                    notification.destroy();
                  }}
                >
                  {i18n._('battle.notification.resume')}
                </ButtonText>
              </SDiv>
            </>
          ),
          placement: 'bottomLeft',
        });
      }
      if (
        data?.battleSubscription?.type ===
          NotificationType.CHALLENGE_ACCEPTED ||
        data?.battleSubscription?.type === NotificationType.CHALLENGE_DECLINED
      ) {
        notification.info({
          icon:
            data?.battleSubscription?.type ===
            NotificationType.CHALLENGE_ACCEPTED ? (
              <CheckCircleOutlined
                style={{ color: `${classic.token?.colorSuccess}` }}
              />
            ) : (
              <CloseCircleOutlined
                style={{ color: `${classic.token?.colorError}` }}
              />
            ),
          message: (
            <SSpan $color={`${classic.token?.colorText}`}>
              {i18n._('battle.defi.title')}
            </SSpan>
          ),
          duration: 3000,
          description: (
            <>
              <SSpanText>
                {`${data?.battleSubscription.from} ${
                  data?.battleSubscription?.type ===
                  NotificationType.CHALLENGE_ACCEPTED
                    ? i18n._('battle.defi.accepted')
                    : i18n._('battle.defi.declined')
                }`}
              </SSpanText>
            </>
          ),
          placement: 'bottomLeft',
        });
        if (
          data?.battleSubscription?.type === NotificationType.CHALLENGE_DECLINED
        ) {
          const newBattes = await refetch();
          if (newBattes.data.checkBattles.hasFinishedBattles) {
            setNotifications(true);
            refetchFinishedBattles();
          }
        }
      }
      if (data?.battleSubscription?.type === NotificationType.BATTLE_INVITE) {
        notification.info({
          icon: (
            <ThunderboltOutlined
              style={{ color: `${classic.token?.colorFillSecondary}` }}
            />
          ),
          message: (
            <SSpan $color={`${classic.token?.colorText}`}>
              {i18n._('battle.defi.title')}
            </SSpan>
          ),
          duration: 0,
          description: (
            <>
              <SSpanText>
                {`${data?.battleSubscription.from} ${i18n._('battle.defi.text')}`}
              </SSpanText>
              <SDiv>
                <ButtonText
                  color="secondary"
                  onClick={() => {
                    navigate('/mode-battle/invitations');
                    notification.destroy();
                  }}
                >
                  {i18n._('battle.defi.show')}
                </ButtonText>
              </SDiv>
            </>
          ),
          placement: 'bottomLeft',
        });
      }
      if (data?.battleSubscription?.type === NotificationType.BATTLE_FINISHED) {
        notification.info({
          icon: (
            <ThunderboltOutlined
              style={{ color: `${classic.token?.colorFillSecondary}` }}
            />
          ),
          message: (
            <SSpan $color={`${classic.token?.colorText}`}>
              {i18n._('battle.defi.title')}
            </SSpan>
          ),
          duration: 0,
          description: (
            <>
              <SSpanText>
                {`${data?.battleSubscription.from} ${i18n._('battle.defi.finished')}`}
              </SSpanText>
              <SDiv>
                <ButtonText
                  color="secondary"
                  onClick={() => {
                    navigate('/mode-battle/recap', {
                      state: {
                        isWinner: data.battleSubscription?.isWinner ?? false,
                        opponent: data?.battleSubscription?.from ?? '',
                      },
                    });
                    setNotifications(false);
                    notification.destroy();
                  }}
                >
                  {i18n._('battle.defi.result')}
                </ButtonText>
              </SDiv>
            </>
          ),
          placement: 'bottomLeft',
        });
        refetchFinishedBattles();
        setNotifications(true);
      }
    },
  });

  const { refetch } = useQuery(GQL_CHECK_BATTLES, {
    client: authClient,
    fetchPolicy: 'network-only',
    onCompleted: (data) => {
      setNotifications(data.checkBattles.hasFinishedBattles);
      if (data.checkBattles.hasPendingBattles) {
        notification.info({
          icon: (
            <ThunderboltOutlined
              style={{ color: `${classic.token?.colorFillSecondary}` }}
            />
          ),
          message: (
            <SSpan $color={`${classic.token?.colorText}`}>
              {i18n._('battle.defi.title')}
            </SSpan>
          ),
          duration: 0,
          description: (
            <>
              <SSpanText>{i18n._('battle.defi.pending')}</SSpanText>
              <SDiv>
                <ButtonText
                  color="secondary"
                  onClick={() => {
                    localStorage.setItem(
                      'lastChecked',
                      new Date().toISOString()
                    );
                    navigate('/mode-battle/invitations');
                    notification.destroy();
                  }}
                >
                  {i18n._('battle.defi.show')}
                </ButtonText>
              </SDiv>
            </>
          ),
          placement: 'bottomLeft',
        });
      }
    },
  });

  const {
    data: finishedBattlesData,
    refetch: refetchFinishedBattles,
    loading,
  } = useQuery(GQL_FINISHED_BATTLES, {
    client: authClient,
    fetchPolicy: 'network-only',
  });

  useEffect(() => {
    if (index) {
      if (index === 'classement') {
        setIndexPage('classement');
      }
      if (index === 'amis') {
        setIndexPage('amis');
      }

      if (index === 'amis') setIndexPage('amis');
    } else {
      setIndexPage(undefined);
    }
  }, []);

  useEffect(() => {
    if (indexPage !== 'classement') return;
    const isRules = localStorage.getItem('epsf-rc');
    if (isRules) {
      setIsRulesNotSeen(false);
    } else {
      setIsRulesNotSeen(true);
    }
  }, [indexPage]);

  function handleRulesSeen() {
    localStorage.setItem('epsf-rc', '1');
    setIsRulesNotSeen(false);
  }

  function handleRulesClick() {
    setIsRulesOpen(true);
  }

  function handleChallengeClick() {
    setIsChallengeListOpen(true);
  }

  useEffect(() => {
    if (index) {
      if (index === 'classement') setIsLeaderBoardOpen(true);
      if (index === 'amis') setIsFriendsOpen(true);
    }
  }, [indexPage]);

  function handleFriendsClick() {
    setIsFriendsOpen(true);
  }

  function handleLeaderBoardClick() {
    setIndexPage('classement');
    setIsLeaderBoardOpen(true);
  }

  // if (payload?.isChallengeable === null) navigate('/first-connection')

  return (
    <GameLayout backgroundSize="cover" blur withoutHeader withoutFooter>
      <Container>
        <SDivMenu>
          <Menu
            onFriendClick={handleFriendsClick}
            hasNotifications={hasNotifications}
            setNotifications={setNotifications}
            onChallengeClick={handleChallengeClick}
          />
        </SDivMenu>
        <SDivContent>
          <SImgLogo src={logo} alt="" />
          <SDivModeChoise>
            <SBtnDiv $justifyContent="flex-end">
              <SquareItem>
                <ButtonSolo
                  onClickRancking={handleLeaderBoardClick}
                  onClick={() => navigate('/mode-solo')}
                />
              </SquareItem>
            </SBtnDiv>
            <SBtnDiv $justifyContent="flex-start">
              <SquareItem>
                <ButtonBattle onClick={() => navigate('/mode-battle')} />
              </SquareItem>
            </SBtnDiv>
          </SDivModeChoise>
        </SDivContent>
        <SDivRules>
          <RulesItem onClick={handleRulesClick} />
        </SDivRules>
      </Container>
      {/* <ChallengeDialog
        onClose={() => {
          setIsChallengeOpen(false);
          setWonBattles([]);
          localStorage.setItem('lastChecked', new Date().toISOString());
        }}
        open={isChallengeOpen}
        wonBattles={wonBattles}
      /> */}

      <LeaderBoardDialog
        onClose={() => {
          setIsLeaderBoardOpen(false);
          navigate('/home');
        }}
        open={isLeaderBoardOpen}
      />
      <FriendsdDialog
        onClose={() => {
          setIsFriendsOpen(false);
          navigate('/home');
        }}
        open={isFriendsOpen}
      />
      <RulesDialog onClose={() => setIsRulesOpen(false)} open={isRulesOpen} />
      <RulesClassementDialog onClose={handleRulesSeen} open={isRulesNotSeen} />

      <ChallengeListDialog
        onClose={() => {
          setNotifications(false);
          setIsChallengeListOpen(false);
        }}
        finishedBattles={finishedBattlesData?.getFinishedBattles}
        loading={loading}
        open={isChallengeListOpen}
      />
    </GameLayout>
  );
}

export default Home;

const SBtnDiv = styled.div<{ $justifyContent?: string }>`
  align-items: center;
  display: flex;
  justify-content: ${({ $justifyContent }) =>
    $justifyContent ? $justifyContent : 'center'};
  flex: 0 0 50%;
  height: 100%;
  padding: 30px;

  @media screen and (orientation: portrait) {
    flex: 0 0 50%;
    width: 90%;
    padding: 10px;
  }
`;
const SImgLogo = styled.img`
  height: 35%;
  width: auto;

  @media screen and (orientation: portrait) {
    height: 25%;
  }

  @media screen and (max-height: 800px) {
    height: 25%;
  }
  @media screen and (max-height: 450px) {
    height: 25%;
  }
  @media screen and (max-width: 450px) {
    height: 25%;
  }
`;

const SDivModeChoise = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-grow: 1;
  width: 100%;

  @media screen and (orientation: portrait) {
    flex-direction: column;
  }
`;

const SDivContent = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 90%;
  width: 100%;
`;

const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  position: relative;
  height: 100%;
  width: 100%;
`;

const SDivMenu = styled.div`
  left: 0;
  top: 0;
  width: 100%;
  position: absolute;
  padding: 5px;
  width: 100%;
  z-index: 2;

  @media screen and (orientation: portrait) {
    padding: 5px;
  }
  @media screen and (max-height: 450px) {
    padding: 5px;
  }
`;

const SDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;
